// modules/user/components/permissions/RoleGuard.tsx

import React from 'react'
import {useReduxAuth} from '../../../auth'

export interface RoleGuardProps {
  // now optional, with a safe default
  allowedRoles?: number[]
  children: React.ReactNode
}

export const RoleGuard: React.FC<RoleGuardProps> = ({allowedRoles = [], children}) => {
  const {currentUser} = useReduxAuth()

  // if no user, or no roles to check against, or user.role_id not in the list → hide
  if (!currentUser || !allowedRoles.includes(currentUser.role_id)) {
    return null
  }

  return <>{children}</>
}
